import { render, staticRenderFns } from "./NlTable.vue?vue&type=template&id=093f224c&scoped=true&"
import script from "./NlTable.vue?vue&type=script&lang=js&"
export * from "./NlTable.vue?vue&type=script&lang=js&"
import style0 from "./NlTable.vue?vue&type=style&index=0&id=093f224c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093f224c",
  null
  
)

export default component.exports